import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { SpriteSvg } from '@/components/common/SpriteSvg';
import { useRef, useState } from 'react';

type Props = {
  type?: 'top' | 'creator';
};

export const Header = ({ type }: Props) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const searchKeywordRef = useRef<HTMLInputElement>(null);
  const closeButtonRef = useRef<HTMLLabelElement>(null);
  const [keyword, setKeyword] = useState<string>(searchParams.get('keyword') || '');

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.nativeEvent.isComposing || e.key !== 'Enter') return;
    onSearchClicked();
  };

  const onSearchClicked = () => {
    navigate(`/channel_posts?keyword=${searchKeywordRef?.current?.value}`);
    closeButtonRef?.current?.click();
  };

  return (
    <header className={`${type} ch`}>
      <div className="ch-wrapper">
        <label htmlFor="menu-opener">
          <SpriteSvg name={'icon-menu'} className={'i'} />
        </label>
        <Link to={'/'} className="ch-logo"></Link>
      </div>
      <div className="header-search">
        <input type="checkbox" className="opener-checkbox" id="header-search-opener" />
        <label htmlFor="header-search-opener" className="header-search-trigger">
          <SpriteSvg name={'icon-search'} className={'i'} />
        </label>
        <label className="backdrop" htmlFor="header-search-opener"></label>
        <div className="search-form">
          <div className="control-wrapper">
            <input
              type="text"
              className="header-search-form"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              ref={searchKeywordRef}
              onKeyDown={onKeyDown}
            />
            <button className="header-search-btn" onClick={onSearchClicked}>
              <SpriteSvg name={'icon-search'} className={'i'} />
            </button>
          </div>
          <label htmlFor="header-search-opener" className="header-search-closer" ref={closeButtonRef}>
            <SpriteSvg name={'icon-modal-close'} className={'i'} />
          </label>
        </div>
      </div>
    </header>
  );
};
